import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  services: [],
  service: null
}

// mutations
export const mutations = {
  [types.SET_SERVICES] (state, services) {
    state.services = services
  },
  [types.SET_SERVICE] (state, service) {
    state.service = service
  },
  [types.FETCH_SERVICE_FAILURE] (state) {
    state.service = null
  }
}

// actions
export const actions = {
  async fetchServices ({ commit }) {
    try {
      const { data } = await axios.get('/api/services')
      commit(types.SET_SERVICES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchService ({ commit }, service) {
    try {
      const { data } = await axios.get(`/api/services/${service.id}`)

      commit(types.SET_SERVICE, { service: data })
    } catch (e) {
      commit(types.FETCH_SERVICE_FAILURE)
    }
  },

  async createService (context, service) {
    try {
      await axios.post('/api/services', service)
      context.dispatch('fetchServices')
    } catch (e) {
      console.log(e)
    }
  },

  async updateService (context, service) {
    try {
      await axios.put(`/api/services/${service.id}`, service)
      context.dispatch('fetchServices')
    } catch (e) { }
  },

  async deleteService (context, service) {
    try {
      await axios.delete(`/api/services/${service.id}`)
      context.dispatch('fetchServices')
    } catch (e) { }
  }
}

// getters
export const getters = {
  services: state => state.services
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/service.js